// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".response-panel[data-v-ed2bc78a]{color:#fff;width:100vw;position:fixed;z-index:10;bottom:0;background-color:#111;overflow-x:scroll;transition:.1s}.response-panel .response-panel-button-close[data-v-ed2bc78a]{position:absolute;top:0;right:16px;font-size:16px}.response-result[data-v-ed2bc78a]{white-space:pre}@media screen and (max-height:450px){.response-panel[data-v-ed2bc78a]{padding-top:15px}.response-panel a[data-v-ed2bc78a]{font-size:18px}}", ""]);
// Exports
module.exports = exports;
